import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../guards/auth.guard';
import { PaystubsComponent } from './paystubs.component';
import { EditPaystubComponent } from './edit-paystub.component';

const routes: Routes = [
  { path: '', component: PaystubsComponent, canActivate: [AuthGuard] },
  {
    path: 'filter/:state',
    component: PaystubsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: ':id/edit',
    component: EditPaystubComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaystubsRoutingModule {}
